import { FC } from "react";

import IconProps from "./IconProps";

const BriefcaseIcon: FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_17206_753)">
      <path
        d="M2.5 7.99992C2.5 7.55789 2.67559 7.13397 2.98816 6.82141C3.30072 6.50885 3.72464 6.33325 4.16667 6.33325H15.8333C16.2754 6.33325 16.6993 6.50885 17.0118 6.82141C17.3244 7.13397 17.5 7.55789 17.5 7.99992V15.4999C17.5 15.9419 17.3244 16.3659 17.0118 16.6784C16.6993 16.991 16.2754 17.1666 15.8333 17.1666H4.16667C3.72464 17.1666 3.30072 16.991 2.98816 16.6784C2.67559 16.3659 2.5 15.9419 2.5 15.4999V7.99992Z"
        stroke="#22BBA7"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.66663 6.33333V4.66667C6.66663 4.22464 6.84222 3.80072 7.15478 3.48816C7.46734 3.17559 7.89127 3 8.33329 3H11.6666C12.1087 3 12.5326 3.17559 12.8451 3.48816C13.1577 3.80072 13.3333 4.22464 13.3333 4.66667V6.33333"
        stroke="#22BBA7"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 10.5V10.5083"
        stroke="#22BBA7"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.5 11.3333C4.82632 12.5055 7.39502 13.1161 10 13.1161C12.605 13.1161 15.1737 12.5055 17.5 11.3333"
        stroke="#22BBA7"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_17206_753">
        <rect width="20" height="20" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default BriefcaseIcon;
